// extracted by mini-css-extract-plugin
module.exports = {"subtotal":"Subtotal_subtotal__4hzkl","subtotal__gift":"Subtotal_subtotal__gift__3JgpF"};